// extracted by mini-css-extract-plugin
module.exports = {"document":"_2RUUH87","page":"_1CwMWTX"};